import {get,post} from '@/api/http.js'

// 访问记录
export function add_pv(params){
	return get('/api/jx/add_pv',params)
}	
//	1、2级菜单（isnav：1  /  parent_id:9 ）
export function channel_list(params){
	return get('/api/jx/channel_list',params)
}	
// 获取内容列表
export function archives_list(params){
	return get('/api/jx/archives_list',params)
}
// 艺品芸
export function archives_list_new(params){
	return get('/api/jx/archives_list_new',params)
}
// 其他刊物列表
export function pdf_list(params){
	return get('/api/jx/pdf_list',params)
}
// 获取自定义文件
export function get_file(params){
	return get('/api/jx/get_file',params)
}
// 获取自定义图片
export function get_file_all(params){
	return get('/api/jx/get_file_all',params)
}
// 获取栏目详情
export function channel_detail(params){
	return get('/api/jx/channel_detail',params)
}
// 获取自定义富文本
export function get_content(params){
	return get('/api/jx/get_content',params)
}
// 获取商品列表
export function product_list(params){
	return get('/api/jx/product_list',params)
}
// 获取PDF详情
export function pdf_detail(params){
	return get('/api/jx/pdf_detail',params)
}
// 获取对应页面海报
export function get_banner(params){
	return get('/api/jx/get_banner',params)
}
// 获取收藏品列表
export function cb_company(params){
	return get('/api/jx/cb_company',params)
}
// 获取弹窗公告
export function get_notice(params){
	return get('/api/jx/get_notice',params)
}
// 获取自定义富文本
export function get_content_all(params){
	return get('/api/jx/get_content_all',params)
}
// 发展大事件
export function history_lst(params){
	return get('/api/jx/history_lst',params)
}
// 获取自定义文本
export function get_text_all(params){
	return get('/api/jx/get_text_all',params)
}
// 新闻详情
export function archives_detail(params){
	return get('/api/jx/archives_detail',params)
}
// 获取班级列表
export function banji_list(params){
	return get('/api/jx/banji_list',params)
}
// 获取学生列表
export function student_list(params){
	return get('/api/jx/student_list',params)
}


